import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SolutionReveal() {
  return <section className="bg-sand px-4 py-20" data-id="element-179" data-mp="1d0cpnrg32dfu">
      <div className="mx-auto max-w-4xl text-center" data-id="element-180" data-mp="1rq23on99ybxj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-181" data-mp="1roqrq05odxvc">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white text-2xl shadow-sm" data-id="element-182" data-mp="u29vky8ohqb6">
            ★
          </span>
          <h2 className="mt-5 font-serif text-3xl font-bold text-navy sm:text-4xl" data-id="element-183" data-mp="182ufxyu8ru6s">
            El sistema más completo de Historia para el aula de habla hispana
          </h2>
          <p className="mt-4 text-lg font-bold text-gold-dark" data-id="element-184" data-mp="2jggbq2ulwu1a">
            Mega Pack Historia 360
          </p>
          <p className="mt-3 text-ink" data-id="element-185" data-mp="2feurtxjnnfhl">
            8 tomos · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>
        <div className="mt-10 grid gap-6 text-left md:grid-cols-2" data-id="element-186" data-mp="2gus8hg7opgx1">
          <div className="space-y-4 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm" data-id="element-187" data-mp="2gsyzvvdigmme">
            {['No es teoría copiada de un manual.', 'No es una colección de actividades sueltas.', 'No es material que tengas que adaptar entero.'].map(text => <p className="flex gap-3 text-sm text-ink" key={text} data-id="element-188" data-mp="1t3egjbdg3ncl">
                <X size={18} className="shrink-0 text-gold" data-id="element-189" data-mp="1x7ccxebdyk1y" />
                {text}
              </p>)}
          </div>
          <div className="rounded-2xl border border-green/20 bg-[#F2FBF4] p-6 shadow-sm" data-id="element-190" data-mp="2242sm0ja3dmu">
            <p className="flex gap-3 font-medium leading-relaxed text-ink" data-id="element-191" data-mp="26yp3m2lg746e">
              <Check size={20} className="shrink-0 text-green" data-id="element-192" data-mp="19gp32nhwtkcr" />
              Es un sistema para que entres al aula con confianza y dictes
              clases que de verdad enseñen a pensar históricamente.
            </p>
          </div>
        </div>
      </div>
    </section>;
}